import React from 'react';
import { Lightbulb, ArrowRight, MoreHorizontal, Calendar } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export interface IdeaCardProps {
  id: string;
  title: string;
  description: string;
  category: string;
  tags: string[];
  dateAdded: string;
  status: 'new' | 'processing' | 'completed';
  onGenerateHooks?: (id: string) => void;
}
export function IdeaCard({
  id,
  title,
  description,
  category,
  tags,
  dateAdded,
  status,
  onGenerateHooks
}: IdeaCardProps) {
  return <Card className="group overflow-hidden border-gray-200 hover:shadow-lg transition-all duration-300 bg-white h-full flex flex-col" data-id="element-490">
      <CardContent className="p-5 flex-1 flex flex-col" data-id="element-491">
        {/* Header */}
        <div className="flex justify-between items-start gap-2 mb-3" data-id="element-492">
          <div className="h-10 w-10 rounded-lg bg-[#139191]/10 flex items-center justify-center flex-shrink-0" data-id="element-493">
            <Lightbulb className="h-5 w-5 text-[#139191]" data-id="element-494" />
          </div>
          <Button variant="ghost" size="icon" className="h-6 w-6 -mr-2 text-gray-400 hover:text-gray-600" data-id="element-495">
            <MoreHorizontal className="h-4 w-4" data-id="element-496" />
          </Button>
        </div>

        {/* Category Badge */}
        <Badge variant="secondary" className="bg-[#139191] text-white hover:bg-[#139191]/90 border-none font-medium px-2.5 mb-3 w-fit" data-id="element-497">
          {category}
        </Badge>

        {/* Title & Description */}
        <h3 className="font-bold text-lg leading-tight text-gray-900 mb-2 line-clamp-2" data-id="element-498">
          {title}
        </h3>
        <p className="text-sm text-gray-600 mb-4 line-clamp-3 flex-1" data-id="element-499">
          {description}
        </p>

        {/* Tags */}
        <div className="flex flex-wrap gap-1.5 mb-4" data-id="element-500">
          {tags.map(tag => <Badge key={tag} variant="outline" className="text-xs font-normal text-gray-600 border-gray-200 bg-gray-50" data-id="element-501">
              {tag}
            </Badge>)}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-auto" data-id="element-502">
          <div className="flex items-center gap-1.5 text-xs text-gray-500" data-id="element-503">
            <Calendar className="h-3.5 w-3.5" data-id="element-504" />
            {dateAdded}
          </div>
          <Button size="sm" onClick={() => onGenerateHooks?.(id)} disabled={status === 'processing'} className="bg-[#139191] hover:bg-[#139191]/90 text-white gap-2 text-xs" data-id="element-505">
            {status === 'processing' ? 'Processing...' : 'Generate Hooks'}
            <ArrowRight className="h-3.5 w-3.5" data-id="element-506" />
          </Button>
        </div>
      </CardContent>
    </Card>;
}